import { useCallback, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Image from "src/components/elements/Image";
import { SiteContext } from "src/context/site";
import Logo from "src/assets/images/logo.png";
import { classNames } from "src/helpers/classNames";
import { apiRequest } from "src/async/apiUtils";
import NotificationBanner from "src/components/shared/NotificationBanner";

const AuthDataLayout = ({ title = "", subTitle = "", children, LinkUpComponent = () => <></>, hideLogo = false }) => {
  const { site } = useContext(SiteContext);

  const SiteImage = useCallback(
    () => (
      <Link
        to={"/login"}
        className="block h-full w-full py-0.5">
        {site?._id && (
          <Image
            src={site?.image_logo ? `${site.image_logo}?${new Date().getTime()}` : Logo}
            alt={"Logo"}
            width={"100%"}
            height={"100%"}
            effect={"blur"}
            classes={"object-contain"}
            hideImageOnError
          />
        )}
      </Link>
    ),

    // eslint-disable-next-line react-hooks/exhaustive-deps
    [site?._id],
  );

  const [activeNotifications, setActiveNotifications] = useState({});

  const getActiveNotifications = useCallback(async () => {
    try {
      const { data } = await apiRequest("GET", "/portal/notifications/active");
      setActiveNotifications(data?.data);
    } catch (error) {
      setActiveNotifications({});
    }
  }, []);

  useEffect(() => {
    getActiveNotifications();
  }, [getActiveNotifications]);

  return (
    <>
      {activeNotifications?.content && window.location.href.includes("/login") && <NotificationBanner data={activeNotifications} />}
      <div className="flex flex-grow flex-col justify-center px-2 py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-lg">
          <div className="min-h-[183px] rounded-lg bg-white shadow-md">
            {!hideLogo && (
              <div className="rounded-t-lg bg-headerColor px-4 py-8 sm:px-10">
                <div className="mx-auto h-20 w-auto max-w-[400px] px-3 lg:px-0">
                  <SiteImage />
                </div>
              </div>
            )}
            <div className="space-y-8 px-4 py-8 sm:px-10">
              <div>
                <div className={classNames("w-full sm:mx-auto", site.background_logo ? "bg-white" : "")}>
                  <h2 className={"text-center text-3xl font-extrabold text-gray-900"}>{title}</h2>
                  <div className="text-regular mt-2 text-center font-medium text-gray-600">{subTitle}</div>
                </div>
              </div>
              <div>
                <div id="msg"></div>
                {children}
                <LinkUpComponent />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthDataLayout;
